import React from "react";
import { Layout } from "antd";

import Resources from "scripts/resources";

const { Footer } = Layout;

export default () => (
  <Footer>
    <div className="copyright">{Resources.copyright}</div>
    <div className="designby">
      <a
        href={process.env.REACT_APP_SITE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {Resources.webDesign}
      </a>{" "}
      {Resources.byOwner}
    </div>
  </Footer>
);
